module.exports = __webpack_public_path__ + "static/media/uisce.63b0dabf.png";